import React from 'react';
import PageContainer from "../../../hoc/PageContainer";

const FellowshipEvent = () => (
    <div>
        <PageContainer page="FellowshipEvent">
            <h1 className="AboutUsTitle">WHAT HAPPENS AT A ROTARY FELLOWSHIP EVENTS?</h1>
            <div className="AboutUsText">
                Rotary Fellowships are
                <b>
                     international groups that share a common passion. Being part of a fellowship is a fun way to make friends around the community, explore a hobby or profession, and enhance your Rotary experience.
                </b>
                <h2 className="AboutUsTitle left">How do I join a fellowship?</h2>
                Fellowships are open to Rotarians, family members, and program participants and alumni. You can contact a fellowship directly by using the links below.
                <h2 className="AboutUsTitle left">How do I form a fellowship?</h2>
                <ul>
                    <li> Find others interested in the topic:
                        <ul>
                            <li>
                                Join a <a href="https://my.rotary.org/en/exchange-ideas/groups" target="_blank"> discussion group </a>
                                 or <a href="https://my.rotary.org/en/exchange-ideas/groups/start" target="_blank">start a new one</a>.
                                It's a great way to share your interest with other members.
                            </li>
                            <li>
                                Use Rotary’s presence on <a href="https://www.facebook.com/rotary" target="_blank">Facebook</a>, <a href="https://twitter.com/rotary" target="_blank">Twitter</a>, and <a href="https://www.linkedin.com/groups/Official-Rotary-International-Group-858557/about/" target="_blank">LinkedIn</a> to promote your idea.
                            </li>
                            <li>
                                Attend the Rotary International Convention or other <a href="https://my.rotary.org/en/exchange-ideas/events" target="_blank">Rotary events.</a>
                            </li>
                            <li>Reach out to district leadership in other countries to build membership.</li>
                        </ul>
                    </li>

                    <li>
                        Apply for official recognition using this
                        <a href={"https://rotary.qualtrics.com/jfe/form/SV_cSG6yQFgv1rdtu5"} target="_blank"> online form.</a>
                    </li>
                </ul>

            </div>
        </PageContainer>
    </div>
);

export default FellowshipEvent;
